export default __webpack_public_path__ + "static/ThinkingBulbIcon-19c634172895d6127204daac75ca8e07.gif";